//Promo
export const ADD_PROMOCODE = "ADD_PROMOCODE";
export const DELETE_PROMOCODE = "DELETE_PROMOCODE";
export const ADD_PROMOCODE_ERROR = "ADD_PROMOCODE_ERROR";
export const DELETE_PROMOCODE_ERROR = "DELETE_PROMOCODE_ERROR";
export const ADD_PROMOCODE_RESPONSE = "ADD_PROMOCODE_RESPONSE";
